import React, { Component } from 'react'
import { extendParentClass, extendBaseClass } from '../../../../utils/classes'
import Joined from './Joined'

export class Bottom extends Component {
  baseClass = extendParentClass.bind(this)('bottom')

  extend = extendBaseClass.bind(this)

  render() {
    return (
      <div className={this.baseClass}>
        <Joined parentClass={this.baseClass} />
        <button className={this.extend('action')}>Get Started</button>
      </div>
    )
  }
}

export default Bottom
